import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { ACTIONS_COL_WIDTH, COL_WIDTH, MAIN_COL_WIDTH, PADDING_COL_WIDTH } from './_constants'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { truncate } from '../../../../utils/helpers/string'
import { useOpenEditProfileModal } from '../../../../utils/routes/modals/modalsActions'
import { useProfiles } from '../_load/ProfilesLoader'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Sticky from '../../../../components/helpers/Sticky'
import Text from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'

const TableHeader = () => {
  const { t } = useTranslation('editPermissions')
  const profiles = useProfiles()
  const openEditModal = useOpenEditProfileModal({ outside: true })

  return (
    <Sticky bgColor={COLORS.white}>
      <Separator usePadding weight={2.5} />
      <Grid gutter={0.2} margin={0} bgColor="white" align="center">
        <Col width={PADDING_COL_WIDTH} />
        <Col width={MAIN_COL_WIDTH} />

        <Col width={ACTIONS_COL_WIDTH}>
          <Text size="xxsmall" bold align="center" color="red">
            {t('all')}
          </Text>
        </Col>

        {profiles.map(profile => (
          <Col key={profile.id} width={COL_WIDTH}>
            <Text size="xxsmall" bold align="center" onClick={() => openEditModal(profile.id)}>
              {truncate(profile.label, 20)}
            </Text>
          </Col>
        ))}

        <Col width={COL_WIDTH}>
          <Icon name="BsFillPlusCircleFill" size={0.85} onClick={() => openEditModal()} />
        </Col>
      </Grid>
      <Separator weight={2} />
      <Line />
      <Separator weight={4} />
    </Sticky>
  )
}

export default TableHeader
